import { render, staticRenderFns } from "./RFMTrackingMessagesSection.vue?vue&type=template&id=14bddf80&scoped=true&"
import script from "./RFMTrackingMessagesSection.vue?vue&type=script&lang=js&"
export * from "./RFMTrackingMessagesSection.vue?vue&type=script&lang=js&"
import style0 from "./RFMTrackingMessagesSection.vue?vue&type=style&index=0&id=14bddf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bddf80",
  null
  
)

export default component.exports